import '../../styles/Projects.css';
import ProjectIcon from "../icons/code-commit-solid.svg"
import Github from "../icons/github-alt-brands-solid.svg"
import YouTube from "../icons/youtube-brands-solid-full.svg"
import Image from "../icons/image-solid-full.svg"
import Images from "../icons/images-solid-full.svg"
import LockIcon from "../icons/lock-solid-full.svg"
import Briefcase from "../icons/briefcase-solid-full.svg"
import Live from "../icons/tower-broadcast-solid-full.svg"
import { useTranslation } from "react-i18next";

function Projects() {
  const { t } = useTranslation();
  return (
    <section className="projects">
        <div className='projects-title'>
            <img className='project-icon' src={ProjectIcon} alt='Projects Icon'/>
            <h2>{t('projects.heading')}</h2>
        </div>
        <div className="projects-wrapper">

            <div className="project">
                <h3>{t('projects.project1.heading')}</h3>
                <p className='description'>
                    {t('projects.project1.description')}
                </p>
                <ul className='project-features'>
                    <li>{t('projects.project1.feature1')}</li>
                    <li>{t('projects.project1.feature2')}</li>
                    <li>{t('projects.project1.feature3')}</li>
                </ul>
                <div className='used-technologies'>
                    <div className='used-technologies-wrapper'>
                        <div className='technology'>WordPress (PHP)</div>
                        <div className='technology'>HTML</div>
                        <div className='technology'>CSS</div>
                        <div className='technology'>JavaScript</div>
                        <div className='technology'>SEO</div>
                        <div className='technology'>Performance</div>
                        <div className='technology'>Security</div>
                        <div className='technology'>Hosting</div>
                        <div className='technology'>Maintenance</div>
                    </div>
                </div>
                <div className="project-buttons">
                    <div className='private-project'>
                        <img
                            className='project-button-icon'
                            src={LockIcon}
                            alt='Private Project Icon'
                        />
                        <p>Private Client Work</p>
                    </div>
                </div>
            </div>

            <div className="project">
                <h3>{t('projects.project2.heading')}</h3>
                <p className='description'>
                {t('projects.project2.description')}
                </p>
                <ul className='project-features'>
                    <li>{t('projects.project2.feature1')}</li>
                    <li>{t('projects.project2.feature2')}</li>
                    <li>{t('projects.project2.feature3')}</li>
                    <li>{t('projects.project2.feature4')}</li>
                    <li>{t('projects.project2.feature5')}</li>
                    <li>{t('projects.project2.feature6')}</li>
                </ul>
                <div className='used-technologies'>
                    <div className='used-technologies-wrapper'>
                        <div className='technology'>ASP.NET Core (C#)</div>
                        <div className='technology'>React (TypeScript)</div>
                        <div className='technology'>PostgreSQL</div>
                        <div className='technology'>JWT</div>
                        <div className='technology'>REST API</div>
                        <div className='technology'>xUnit</div>
                        <div className='technology'>Docker</div>
                    </div>
                </div>
                <div className="project-buttons">
                    <a className='github' target='_blank' href='https://github.com/bogdanmaric/cinema-vision-frontend'>
                        <img className='project-button-icon' src={Github} alt='Project Github Icon'/>
                        <p>{t('projects.project2.label1')}</p>
                    </a>
                    <a className='github' target='_blank' href='https://github.com/bogdanmaric/cinema-vision-backend'>
                        <img className='project-button-icon' src={Github} alt='Project Github Icon'/>
                        <p>{t('projects.project2.label2')}</p>
                    </a>
                    <a className='github' target='_blank' href='https://www.youtube.com/watch?v=aJVNwltKXqQ'>
                        <img className='project-button-icon' src={YouTube} alt='Project Youtube Icon'/>
                        <p>{t('projects.project2.label3')}</p>
                    </a>
                </div>
            </div>

            <div className="project">
                <h3>{t('projects.project3.heading')}</h3>
                <p className='description'>
                    {t('projects.project3.description')}
                </p>
                <ul className='project-features'>
                    <li>{t('projects.project3.feature1')}</li>
                    <li>{t('projects.project3.feature2')}</li>
                    <li>{t('projects.project3.feature3')}</li>
                    <li>{t('projects.project3.feature4')}</li>
                </ul>
                <div className='used-technologies'>
                    <div className='used-technologies-wrapper'>
                        <div className='technology'>Laravel (PHP)</div>
                        <div className='technology'>Blade</div>
                        <div className='technology'>Breeze</div>
                        <div className='technology'>Purify</div>
                        <div className='technology'>2FA</div>
                        <div className='technology'>MySQL</div>
                    </div>
                </div>
                <div className="project-buttons">
                    <a className='github' target='_blank' href='https://www.youtube.com/watch?v=8tPsKh630KQ'>
                        <img className='project-button-icon' src={YouTube} alt='Project Youtube Icon'/>
                        <p>{t('projects.project3.label')}</p>
                    </a>
                </div>
            </div>

        </div>
    </section>
  );
}

export default Projects;